import script from "./BookAdCarousel.vue?vue&type=script&setup=true&lang=js"
export * from "./BookAdCarousel.vue?vue&type=script&setup=true&lang=js"

import "./BookAdCarousel.vue?vue&type=style&index=0&id=1a3c729f&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a3c729f"]])

export default __exports__